/** The Tekst box scrolls after this. Twenty-ish lines in the report tool. */
export const REPORT_TEXT_BOX_MAX_PX = 512;

/**
 * Height for a free-text box. `scrollHeight` is read while the textarea's
 * height is `auto`, so it is the content height rather than the previous box.
 * A zero reading leaves the CSS minimum in place.
 */
export function measureGrowingTextarea(
  node: HTMLTextAreaElement,
  maxPx = REPORT_TEXT_BOX_MAX_PX,
): { height: number; scroll: boolean } {
  const previous = node.style.height;
  node.style.height = 'auto';
  const needed = node.scrollHeight;
  node.style.height = previous;
  if (!Number.isFinite(needed) || needed <= 0) return { height: 0, scroll: false };
  if (needed > maxPx) return { height: maxPx, scroll: true };
  return { height: needed, scroll: false };
}
